// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import voca from 'voca'
import Vue2Filters from 'vue2-filters'
import App from './App'
import Clock from '@/components/Clock'
import createRouter from './router'
import { configAuthFromRouter } from './utils/auth'
import i18n, { configLangFromRouter } from './utils/i18n'
import format from 'string-format'
import * as Sentry from '@sentry/browser'
import { Vue as VueSentry } from '@sentry/integrations'
import Config from '@/config'
import Assessment from '@/components/Assessment.vue'

// import Progress from './components/Progress'

Vue.config.productionTip = false
format.extend(String.prototype)

console.debug('Main.js')
const router = createRouter(Assessment)
console.debug('  currentRoute: ', router.currentRoute.fullPath)
console.debug(process.env.NODE_ENV)

Sentry.init({
  dsn: Config.sentryDsn,
  release: window.GIT_REVISION,
  integrations: [new VueSentry({ Vue, attachProps: true, logErrors: Config.vueLogErrors })]
})

Vue.use(Vue2Filters)

Vue.filter('asTime', (value) => {
  const seconds = value % 60
  const minutes = Math.floor((value / 60)) % 60
  const hours = Math.floor((value / 3600))

  // return `${hours}:${minutes}:${seconds}`
  return voca.sprintf('%02d:%02d:%02d', hours, minutes, seconds)
})

/* eslint-disable no-new  */
new Vue({
  el: '#timer',
  components: { Clock },
  template: '<Clock/>',
  i18n
})

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',

  created () {
    // NOTE: this is hackish - configAuthFromRouter has to come last as that removes the extra query params from the url
    configLangFromRouter(this, router)
    // Have to do it here as the Http module gets initialized before router due to the imports. (TODO: find a better place?)
    // TODO: maybe use something like vue-auth (that would handle redirects to the login page and token expiration as well)
    configAuthFromRouter(router)
  }
})

// new Vue({
//   el: '#top-progress',
//   components: {Progress},
//   template: '<Progress/>'
// })

console.debug('Main.js end')
